import PropTypes from 'prop-types'
import React, { Component } from 'react'

class BuyModal extends Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  render() {
    const { children } = this.props
    return <div className="buymodal-children-wrapper">{children}</div>
  }
}

BuyModal.propTypes = {
  children: PropTypes.element.isRequired,
}

export default BuyModal
